module.exports = __webpack_public_path__ + "img/pernell-logo.e4754b04.jpg";